// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xzuh","signatureBlock":"Footer_signatureBlock__14GR-","signature":"Footer_signature__XLjDh"};